var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 24.5,
    viewBox: "0 0 24.5 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_80528",
    "data-name": "Path 80528",
    d: "M7,6A1,1,0,0,1,8,5h8a1,1,0,0,1,0,2H8A1,1,0,0,1,7,6Zm1,5h6a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Zm16,1.708V19a5.006,5.006,0,0,1-5,5H5a5.006,5.006,0,0,1-5-5V12.708A5.026,5.026,0,0,1,1.541,9.1L3,7.7V4A4,4,0,0,1,7,0H17a4,4,0,0,1,4,4V7.7l1.459,1.4A5.025,5.025,0,0,1,24,12.707ZM5,4v8.243l4.878,4.879a3.073,3.073,0,0,0,4.243,0L19,12.243V4a2,2,0,0,0-2-2H7A2,2,0,0,0,5,4Zm17,8.708a2.953,2.953,0,0,0-.058-.579l-6.407,6.407a5,5,0,0,1-7.071,0L2.058,12.128A2.953,2.953,0,0,0,2,12.707V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V12.707Z",
    transform: "translate(0.25 0.25)",
    fill: "#0b482c",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f2e875caf8c4e4d5c4eef256e03f806e.svg";
export { ForwardRef as ReactComponent };